<template>
	<card :xs-tile="xsTile" :flat="flat">
		<div class="flex justify-between px-16 pt-20 pb-10">
			<div class="flex items-center">
				<skeleton :height="36" :width="36" rounded-full/>
				<div class="flex ml-16 flex-column">
					<skeleton :height="14" class="mb-4" :width="200" rounded/>
					<skeleton :height="11" :width="100" rounded/>
				</div>
			</div>
		</div>

		<div class="pt-8">
			<skeleton :height="100" width="100%"/>
		</div>

		<div class="flex justify-between items-center px-16 lg:px-24">
			<skeleton :height="14" rounded :width="120"/>

			<btn-group class="justify-end" text>
				<btn large text disabled>
					<skeleton :height="24" rounded :width="36"/>
				</btn>
				<btn large text disabled>
					<skeleton :height="24" rounded :width="36"/>
				</btn>
			</btn-group>
		</div>
	</card>
</template>

<script>
import GridElement from "../../Layout/Grid/GridElement";

export default {
	name: 'ActivitySkeleton',

	mixins: [GridElement],

	props: {
		// Whether to prevent any shadow
		flat: {
			type: Boolean,
			default: false
		}
	},
}
</script>

